import { render, staticRenderFns } from "./referralInput.vue?vue&type=template&id=b8640824&scoped=true"
import script from "./referralInput.vue?vue&type=script&lang=js"
export * from "./referralInput.vue?vue&type=script&lang=js"
import style0 from "./referralInput.vue?vue&type=style&index=0&id=b8640824&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8640824",
  null
  
)

export default component.exports